import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FileUploader from "../../../reusableComponents/FileUploader2";
import { Col, Container, Row, Table } from "react-bootstrap";
import ButtonWrapper from "../../../components/Button";
import { useSelector } from "react-redux";
import KmlFileUploader from "../../../../TCPForms/reusableComponents/KmlFileUploader";
import InputWrapper from "../../../layout/inputWrapper";

const Step2 = ({ formData, isUpdating, handleTabChange, t, initFormMTDocs }) => {
  const { documents } = useSelector((state) => state.formMT);

  const [coordinate, setCoordinate] = useState([{ latitude: "", longitude: "" }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  console.log("documentFromRedux", documents, formData);
  console.log("documentsectionRendered");

  // let riskType = "";
  // if (activityAsPerMap == "Residential") {
  //   if (activityProposed == "Row Houses") {
  //     if (developmentArea == "Built Up") {
  //       if (landArea <= 100) {
  //         riskType = "LOW";
  //       }
  //     }
  //   }
  // } else if (activityAsPerMap == "Residential") {
  //   if (activityProposed == "Row Houses" || activityProposed == "Semi Detached" || activityProposed == "Detached") {
  //     if (developmentArea == "Built Up") {
  //       if (landArea > 100) {
  //         if (schemeType == "Non Scheme") riskType = "HIGH";
  //       }
  //     }
  //   }
  // } else if (activityAsPerMap == "Residential") {
  //   if (activityProposed == "Row Houses" || activityProposed == "Semi Detached" || activityProposed == "Detached") {
  //     if (schemeType == "Non Scheme") riskType = "HIGH";
  //   }
  // } else if (activityAsPerMap == "Residential") {
  //   if (activityProposed == "Row Houses" || activityProposed == "Semi Detached" || activityProposed == "Detached") {
  //     if (schemeType == "Scheme") riskType = "LOW";
  //   }
  // } else if (activityAsPerMap == "Residential") {
  //   if (
  //     activityProposed == "Multi Unit" ||
  //     activityProposed == "Group Housing" ||
  //     activityProposed == "EWS Group Housing" ||
  //     activityProposed == "LIG Group Housing" ||
  //     activityProposed == "Affordable Group Housing"
  //   ) {
  //     riskType = "HIGH_NIVESH";
  //   }
  // } else if (activityAsPerMap == "Residential") {
  //   if (
  //     activityProposed == "Multi Unit" ||
  //     activityProposed == "Group Housing" ||
  //     activityProposed == "EWS Group Housing" ||
  //     activityProposed == "LIG Group Housing" ||
  //     activityProposed == "Affordable Group Housing"
  //   ) {
  //     riskType = "HIGH_NIVESH";
  //   }
  // } else {
  //   riskType = "HIGH_NIVESH";
  // }
  const determineRiskType = (formData) => {
    const { activityAsPerMap, activityProposed, developmentArea, landArea, schemeType } = formData?.descriptionOfLand || {};

    let riskType = "HIGH_NIVESH"; // Default

    if (activityAsPerMap === "Residential") {
      // Check for group housing types
      if (
        activityProposed === "Multi Unit" ||
        activityProposed === "Group Housing" ||
        activityProposed === "EWS Group Housing" ||
        activityProposed === "LIG Group Housing" ||
        activityProposed === "Affordable Group Housing"
      ) {
        riskType = "HIGH_NIVESH";
      }

      // Check for row house types
      else if (activityProposed === "Row Houses" || activityProposed === "Semi Detached" || activityProposed === "Detached") {
        if (developmentArea === "Built Up") {
          if (landArea <= 100) {
            riskType = "LOW";
          } else {
            if (schemeType === "Non Scheme") {
              riskType = "HIGH";
            }
          }
        } else {
          if (schemeType === "Non Scheme") {
            riskType = "HIGH";
          } else if (schemeType === "Scheme") {
            riskType = "LOW";
          }
        }
      }
    }

    return riskType;
  };

  // Usage:
  const riskType = determineRiskType(formData);
  console.log("FinalriskType", riskType);
  const validateFiles = () => {
    const uploadedDocs = new Set(documents?.map((doc) => doc.documentType)); // Using Set for faster lookups
    const requiredDocs =
      formData?.descriptionOfLand?.schemeType === "Scheme"
        ? ["completeDrawingFile", "allotmentLetterPossessionLetter", "registrySaleDeedHPTA"]
        : ["completeDrawingFile", "registrySaleDeedHPTA"];

    return requiredDocs.every((doc) => uploadedDocs.has(doc)); // Use Set.has for O(1) lookup
  };

  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData.descriptionOfLand,
      googleMapCoordinates: formData?.descriptionOfLand?.googleMapCoordinates || coordinate,
      googleMapLocation: formData?.descriptionOfLand?.googleMapLocation || googleLocation,
    },
    documents: documents,
  };
  const isSchemeType = formData?.descriptionOfLand?.schemeType === "Scheme";
  const { handleSubmit, control, reset, setValue, getValues } = useForm({ defaultValues });
  const handleFormSubmit = (data) => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  //  const handleFormSubmit = (data) => {
  //     const isValid = validateFiles();

  //     console.log("insideFormSubmit", data, isValid);
  //     if (isValid) {
  //       console.log("submitIf", isValid, data);
  //       onSubmit(data);
  //     } else {
  //       setShowError(true);
  //       console.log("submitElse", isValid, showError);
  //       return;
  //     }
  //   };

  useEffect(() => {
    console.log("insideStep3effect");

    if (formData?.documents?.length > 0) {
      console.log("insideStep3effectIfCondition", formData?.documents?.length);
      initFormMTDocs(formData.documents);
    }
  }, [formData?.documents, formData?.descriptionOfLand?.schemeType]);

  // useEffect(() => {
  //   console.log("insideStep3effect");

  //   console.log("insideStep3effectIfCondition", formData?.documents?.length);
  //   if (formData?.documents?.length > 0) {
  //     console.log("insideStep3effectIfCondition", formData?.documents?.length);
  //     initFormMTDocs(formData.documents);
  //   }
  // }, [formData?.documents]);
  const handleClick = () => {
    window.open("https://www.youtube.com/watch?v=TOYanGZdJxo", "_blank");
  };
  const onSubmit = (data) => {
    const allowedDocs = isSchemeType
      ? [
          "completeDrawingFile",
          // "landOwnershipDoc",
          "kmlFile",
          "allotmentLetterPossessionLetter",
          "registrySaleDeedHPTA",
          "sajraPlan",
          "giftDeed",
          "applicantPhoto",
          "signature",
          "approvalLetter",
          "drawingPdf",
        ]
      : [
          "completeDrawingFile",
          // "landOwnershipDoc",
          "kmlFile",
          "developerConsortiumSalesAgreement",
          "khatauni",
          "registrySaleDeedHPTA",
          "mutationLetter",
          "sajraPlan",
          "applicantPhoto",
          "signature",
          "approvalLetter",
          "drawingPdf",
        ];
    const conditionalDocs = documents?.filter((doc) => allowedDocs.includes(doc.documentType) || doc.documentType?.startsWith("signature_"));
    console.log("conditionalDocs", conditionalDocs);

    data = {
      ...data,
      riskType,
      descriptionOfLand: {
        ...data.descriptionOfLand,
        googleMapCoordinates: coordinate,
        googleMapLocation: googleLocation,
      },
      documents: conditionalDocs,
    };
    console.log("dataFromstep2", data);
    handleTabChange(2, data);

    console.log("insdieElseFromsubmit", showError);
  };
  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Documents")}</h2>
          </div>

          <Container className="formInputContainer common-app-form px-3" fluid>
            <Row>
              {/* <Col className="col-sm-12">
                <div
                  style={{
                    // padding: "6px",
                    borderRadius: "5px",
                    color: "#333",
                    margin: "9px 0px",
                    fontWeight: "600",
                    textAlign: "right",
                  }}
                >
                  <span style={{ textAlign: "right", color: "rgb(2, 11, 15)", padding: "9px", backgroundColor: "#fff" }}>
                    <span className="clickHere" onClick={handleClick}>
                      Click here,
                    </span>
                    &nbsp;to know how to create a .kml file.
                  </span>
                </div>
              </Col> */}
            </Row>
            {/* <Row>
              <Col onChange={(e) => handleCoordinateChange("latitude", e.target.value)}>
                <InputWrapper
                  label="Latitude"
                  control={control}
                  placeholder="Enter Latitude"
                  name="descriptionOfLand.latitude"
                  type="decimal"
                  mandatory
                  isRequired={true}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  minLength={8}
                  maxLength={10}
                />
              </Col>
              <Col onChange={(e) => handleCoordinateChange("longitude", e.target.value)}>
                <InputWrapper
                  label="Longitude"
                  control={control}
                  placeholder="Enter Longitude"
                  name="descriptionOfLand.longitude"
                  type="decimal"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={10}
                  minLength={8}
                />
              </Col>
            </Row> */}
            <Row>
              <Col className="col-sm-4">
                <div className="custom-upload new-custom-uploader">
                  <FileUploader
                    isMandatory
                    // hasLabel={false}
                    label="Complete drawing including location/site plan, key plan"
                    control={control}
                    name="completeDrawingFile"
                    validationMsg="Upload File"
                    required
                    tab={4}
                    showError={showError}
                    maxFiles={1}
                  />
                </div>
              </Col>
              {isSchemeType && (
                <Col className="col-sm-4">
                  <div className="custom-upload new-custom-uploader">
                    <FileUploader
                      // hasLabel={false}
                      isMandatory
                      required
                      label="Allotment letter/Possession letter"
                      control={control}
                      name="allotmentLetterPossessionLetter"
                      validationMsg="Upload File"
                      tab={4}
                      showError={showError}
                      maxFiles={1}
                    />
                  </div>
                </Col>
              )}

              {isSchemeType ? (
                <React.Fragment>
                  <Col className="col-sm-4">
                    <div className="custom-upload new-custom-uploader">
                      <FileUploader
                        // hasLabel={false}
                        isMandatory
                        required
                        label="Registry/Sale deed/HPTA/Land ownership/Gift deed"
                        control={control}
                        name="registrySaleDeedHPTA"
                        validationMsg="Upload File"
                        tab={4}
                        showError={showError}
                        maxFiles={4}
                        isMigrated={true}
                      />
                    </div>
                  </Col>
                  {/* <Col>
                    <div className="custom-upload">
                      <FileUploader
                        // hasLabel={false}
                        control={control}
                        label="Gift Deed"
                        name="giftDeed"
                        validationMsg="Upload File"
                        tab={4}
                        maxFiles={1}
                      />
                    </div>
                  </Col> */}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Col className="col-sm-4">
                    <div className="custom-upload new-custom-uploader">
                      <FileUploader
                        // hasLabel={false}
                        // isMandatory
                        // required
                        label="Developer/Consortium/Sales Agreement"
                        control={control}
                        name="developerConsortiumSalesAgreement"
                        validationMsg="Upload File"
                        tab={4}
                        showError={showError}
                        maxFiles={1}
                      />
                    </div>
                  </Col>
                  <Col className="col-sm-4">
                    <div className="custom-upload new-custom-uploader">
                      <FileUploader
                        // isMandatory
                        // hasLabel={false}
                        control={control}
                        label="Khatauni"
                        name="khatauni"
                        validationMsg="Upload File"
                        // required
                        showError={showError}
                        tab={4}
                        maxFiles={1}
                      />
                    </div>
                  </Col>

                  <Col className="col-sm-4">
                    <div className="custom-upload new-custom-uploader">
                      <FileUploader
                        // hasLabel={false}
                        label="Registry/Sale deed/HPTA/Land ownership/Gift deed"
                        control={control}
                        name="registrySaleDeedHPTA"
                        validationMsg="Upload File"
                        tab={4}
                        showError={showError}
                        maxFiles={4}
                        isMandatory
                        required
                        isMigrated={true}
                      />
                    </div>
                  </Col>
                  <Col className="col-sm-4">
                    <div className="custom-upload new-custom-uploader">
                      <FileUploader
                        // isMandatory
                        // required
                        // hasLabel={false}
                        control={control}
                        label="Mutation Letter"
                        name="mutationLetter"
                        validationMsg="Upload File"
                        showError={showError}
                        tab={4}
                        maxFiles={1}
                        isMigrated={true}
                      />
                    </div>
                  </Col>

                  <Col className="col-sm-4">
                    <div className="custom-upload new-custom-uploader">
                      <FileUploader
                        // hasLabel={false}
                        label="Site Superimposed on Sajra Plan"
                        control={control}
                        name="sajraPlan"
                        validationMsg="Upload File"
                        tab={4}
                        showError={showError}
                        maxFiles={1}
                      />
                    </div>
                  </Col>
                </React.Fragment>
              )}
            </Row>
            {/* <Row>
             
              <Col>
                <FileUploader
                  isMandatory
                  // hasLabel={false}
                  control={control}
                  label="Land Ownership Document"
                  name="landOwnershipDoc"
                  validationMsg="Upload File"
                  required
                  showError={showError}
                  tab={4}
                  maxFiles={1}
                />
              </Col>
            </Row> */}

            <Row>
              <Col md={12}>
                <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
              </Col>
            </Row>
          </Container>
          <div className="footerContainer2">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                onClick={() => {
                  handleTabChange(0);
                }}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="submit"
                sx={{ backgroundColor: "#000", marginRight: "4px" }}
              />
            </div>
          </div>
        </div>
      </form>
    </section>
  );
};

export default Step2;
